import React from "react";
import { format, parseISO } from "date-fns";
import { useQuery } from "@tanstack/react-query";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";
import _questions from "./_questions";

export default function Submitted() {
  const {
    data: {
      open_houses,
      results: [
        {
          submission: {
            open_house: { id }
          }
        }
      ]
    }
  } = useQuery(["application"]);
  const open_house_start_dttm = open_houses
    .filter((n) => n.id === id)
    .reduce((n, m) => m.start_dttm, []);
  return (
    <Page>
      <PageHeader title="" tagline="Application Submitted" />
      {id !== 0 && id !== null && (
        <P>
          Waiting is the hardest part but we&apos;ll be seeing you at your Open House on <br />
          <strong>{format(parseISO(open_house_start_dttm), "PPPP p")}</strong>
        </P>
      )}
      {id === 0 && (
        <P>
          Thank you for applying! As a reminder, we aren&apos;t able to review your application
          until you attend an Open House. When you&apos;re ready to pick a date, return here and
          we&apos;ll save you a seat. Cheers!
        </P>
      )}
      {id === null && (
        <>
          <P>
            Thank you!
          </P>
          <P>
            The Battery Team will be in touch shortly with more information on activating your Creative in Residence Membership. Cheers!
          </P>
        </>
      )}
    </Page>
  );
}
